import axiosInstance from '@/utils/api.js'

var state = {
  profilesOfDocuments: []
}

var getters = {
  PROFILES_OF_DOCUMENTS: (state) => {
    return state.profilesOfDocuments
  }
}

var mutations = {
  SET_PROFILES_OF_DOCUMENTS: (state, payload) => {
    state.profilesOfDocuments = payload
  }
}

var actions = {
  GET_PROFILES_OF_DOCUMENTS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/documents/profiles')
    if (result.status === 200) {
      context.commit('SET_PROFILES_OF_DOCUMENTS', result.data)
    }
  },
  CREATE_PROFILES_OF_DOCUMENTS: (context, payload) => {
    return axiosInstance.post('/settings/documents/profiles', payload)
  },
  UPDATE_PROFILES_OF_DOCUMENTS: (context, payload) => {
    return axiosInstance.put('/settings/documents/profiles', payload)
  },
  DELETE_PROFILES_OF_DOCUMENTS: (context, payload) => {
    return axiosInstance.delete('/settings/documents/profiles?profile_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/profilesOfDocuments.js